const privacyPolicyList = [
    {
        name: 'HIPAA Authorization',
        href: 'https://getamplifylife.com/policy/hipaa-compliant-authorization-for-life-insurance',
        id: 'HIPAA Compliant Authorization for Life Insurance',
    },
    {
        name: 'Electronic Record and Signature Disclosure',
        href: 'https://getamplifylife.com/policy/electronic-record-and-signature-disclosure-and-consent',
        id: 'Electronic Record and Signature Disclosure and Consent',
    },
    {
        name: 'Telephone Consumer Protection Act and State-Law Equivalents',
        href: 'https://getamplifylife.com/policy/telephone-consumer-protection-act-and-state-law-equivalents',
        id: 'Telephone Consumer Protection Act and State-Law Equivalents',
    },
    {
        name: 'Voice Signature Authorization',
        href: 'https://getamplifylife.com/policy/voice-signature-authorization',
        id: 'Voice Signature Authorization',
    },
    {
        name: 'Terms and Conditions',
        href: 'https://www.getamplifylife.com/terms-and-conditions',
        id: 'Terms And Conditions',
    },
    {
        name: 'Fraud Statement',
        href: 'https://www.getamplifylife.com/policy/fraud-statement',
        id: 'Fraud Statement',
    },
    {
        name: 'FCRA Authorization',
        href: 'https://getamplifylife.com/policy/fcra-authorization',
        id: 'Disclosure and Authorization for Consumer Report',
    },
];

const reviews = [
    {
        consumer: {
            displayName: 'William Delgado',
        },
        stars: 5,
        text: 'It was a pleasure doing business with them. When I needed to ask question they responded right away. I appreciate the communication skills. They took the time to help me to get the right policy for me and my family. This company is highly recommended. Thank you.',
    },
    {
        consumer: {
            displayName: 'Sheree smiling',
        },
        stars: 5,
        text: 'Great information was shared very thoroughly explained by Scott. Friendly service and excellent communication. Highly recommended.',
    },
    {
        consumer: {
            displayName: 'Trina Stewart',
        },
        stars: 5,
        text: 'I’ve had a fantastic experience with Amplify Life. The platform is easy to use, well organized, and truly helps me stay on top of my goals. What stood out most was their customer support—quick, friendly, and genuinely invested in helping me get the most out of the product.',
    },
];

const FORM_LPV1_PARAMETER = 'formLPV1';

const barValues = [4, 37, 64, 64, 81, 115, 141, 156, 168, 168, 174, 182, 202, 226, 254, 297, 331, 351];
const curveValues = [0, 72, 70, 64, 86, 123, 162, 182, 143, 118, 125, 162, 206, 260, 290, 307, 315, 320];

const barValuesMobile = [74, 141, 141, 216, 289];
const curveValuesMobile = [84, 185, 90, 180, 260];

const barData = {
    type: 'bar',
    label: 'Bars',
    data: barValues,
    backgroundColor: '#DEF9E7',
    borderColor: '#8CEBAC',
    borderWidth: 2,
    borderRadius: 0,
    order: 2,
    categoryPercentage: 0.9,
};

const dotOptions = {
    type: 'scatter',
    label: 'Dot',
    pointBackgroundColor: '#5AE288',
    pointBorderColor: '#FFFFFF',
    pointBorderWidth: 2.66,
    hoverBackgroundColor: '#5AE288',
    hoverBorderColor: '#FFFFFF',
    pointRadius: 16,
    pointHoverRadius: 16,
    pointStyle: 'circle',
    order: 1,
};

const dot1Data = {
    ...dotOptions,
    data: [{x: 10, y: 168}],
};

const dot2Data = {
    ...dotOptions,
    data: [{x: 14, y: 226}],
};

const dot1DataMobile = {
    ...dotOptions,
    data: [{x: 1, y: 84}],
};

const dot2DataMobile = {
    ...dotOptions,
    data: [{x: 3, y: 141}],
};

const barDataMobile = {
    ...barData,
    data: barValuesMobile,
};

const curveData = {
    type: 'line',
    label: 'Curve',
    data: curveValues,
    borderWidth: 2,
    borderColor: '#BAC9C7',
    tension: 0.4,
    pointRadius: 0,
    fill: true,
    backgroundColor: 'rgba(244, 240, 215, 0.4)',
    order: 3,
    cubicInterpolationMode: 'default',
};

const curveDataMobile = {
    ...curveData,
    data: curveValuesMobile,
};

const annotationOptions = {
    type: 'line',
    borderColor: '#456D69',
    borderWidth: 2,
    borderDash: [6, 6],
    label: {
        enabled: true,
        position: 'end',
        backgroundColor: '#fff',
        color: '#174943',
        borderRadius: 21,
        borderWidth: 1,
        borderColor: '#8CEBAC',
        yAdjust: -15.5,
        padding: {top: 16, bottom: 16, left: 22, right: 22},
        font: {
            family: 'Fredoka, sans-serif',
            weight: 'normal',
            size: 21,
        },
    },
    drawTime: 'afterDatasetsDraw',
};

const options = {
    responsive: true,
    plugins: {
        tooltip: {
            enabled: false, // disable hover tooltips
        },
        legend: {display: false},
        annotation: {
            annotations: {
                floor: {
                    ...annotationOptions,
                    xMin: 9,
                    xMax: 9,
                    yMin: 186,
                    yMax: 368,
                    label: {
                        ...annotationOptions.label,
                        xAdjust: -102,
                        content: ['Floor minimizes or', 'prevents losses.'],
                    },
                },
                ceiling: {
                    ...annotationOptions,
                    xMin: 13,
                    xMax: 13,
                    yMin: 244,
                    yMax: 426,
                    label: {
                        ...annotationOptions.label,
                        xAdjust: 104,
                        content: ['Ceiling limits growth ', 'to a max amount.'],
                    },
                },
            },
        },
    },
    scales: {
        x: {
            grid: {display: false, drawTicks: false},
            ticks: {
                font: {
                    size: 22,
                },
                color: '#2E5B56',
                callback: (_, index) => {
                    if (index === 0) return '0yrs';

                    return [2, 7, 12, 17].includes(index) ? `${index + 3}yrs` : '';
                },
            },
        },
        y: {
            display: false,
            grid: {display: false},
        },
    },
};

const annotationOptionsMobile = {
    ...annotationOptions,
    label: {
        ...annotationOptions.label,
        font: {
            family: 'Fredoka, sans-serif',
            weight: 'normal',
            size: 13,
        },
    },
};

const optionsMobile = {
    responsive: true,
    plugins: {
        tooltip: {enabled: false},
        legend: {display: false},
        annotation: {
            annotations: {
                floor: {
                    ...annotationOptionsMobile,
                    xMin: 2,
                    xMax: 2,
                    yMin: 166,
                    yMax: 350,
                    label: {
                        ...annotationOptionsMobile.label,
                        xAdjust: 64,
                        padding: {top: 16, bottom: 16, left: 12, right: 12},
                        content: ['Floor minimizes or', 'prevents losses.'],
                    },
                },
                ceiling: {
                    ...annotationOptionsMobile,
                    xMin: 0,
                    xMax: 0,
                    yMin: 109,
                    yMax: 220,
                    label: {
                        ...annotationOptionsMobile.label,
                        xAdjust: 20,
                        padding: {top: 14, bottom: 14, left: 10, right: 10},
                        content: ['Ceiling limits growth ', 'to a max amount.'],
                    },
                },
            },
        },
    },
    scales: {
        x: {
            grid: {display: false, drawTicks: false},
            ticks: {
                font: {
                    size: 16,
                },
                color: '#2E5B56',
                callback: (_, index) => `${(index + 1) * 5}yrs`,
            },
        },
        y: {
            display: false,
            grid: {display: false},
            min: 0,
            max: 420,
        },
    },
};

export {
    privacyPolicyList,
    FORM_LPV1_PARAMETER,
    options,
    optionsMobile,
    barData,
    barDataMobile,
    curveData,
    curveDataMobile,
    reviews,
    dot1Data,
    dot2Data,
    dot1DataMobile,
    dot2DataMobile,
};
